export const LEARN_MORE_URL = 'https://www.learnwith.ai/money-back-guarantee';
